// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectProject_projects__1rhBJ {
  position: relative;
  margin-right: 16px;
}
.SelectProject_projects__list__LtjjM {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 14px;
  min-width: 229px;
  border: 1px solid #E0E7EB;
  border-radius: 4px;
  background: white;
}

.SelectProject_current__OlJ8A {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.SelectProject_current__name__7bYU8 {
  margin-left: 6px;
  font-weight: 400;
  font-size: 14px;
  white-space: nowrap;
  max-width: 250px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.SelectProject_current__arrow__eSTp4 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  transition: var(--transition);
}
.SelectProject_current--open__8CM4c .SelectProject_current__arrow__eSTp4 {
  transform: scaleY(-1);
}

.SelectProject_project__h5NE\\+ {
  display: flex;
  align-items: center;
  padding: 6px 12px 6px;
  position: relative;
  border-bottom: 1px solid #E0E7EB;
  cursor: pointer;
}
.SelectProject_project__h5NE\\+:first-child {
  padding-top: 6px;
}
.SelectProject_project__h5NE\\+:last-child {
  border-bottom: 0;
  padding-bottom: 7px;
}
.SelectProject_project--selected__51PLY {
  pointer-events: none;
}
.SelectProject_project__name__dxLGL {
  margin-left: 8px;
  font-weight: 400;
  font-size: 12px;
  margin-right: 8px;
}
.SelectProject_project__check__hI\\+a8 {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.SelectProject_project__check__hI\\+a8 svg {
  fill: var(--accent-color);
}
.SelectProject_project__h5NE\\+:hover {
  background: #EEE;
}`, "",{"version":3,"sources":["webpack://./src/components/SelectProject/SelectProject.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,kBAAA;AACF;AACE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;AAAF;AAIE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,6BAAA;AAHJ;AAQM;EACE,qBAAA;AANR;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gCAAA;EACA,eAAA;AATF;AAWE;EACE,gBAAA;AATJ;AAYE;EACE,gBAAA;EACA,mBAAA;AAVJ;AAaE;EACE,oBAAA;AAXJ;AAcE;EACE,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAZJ;AAeE;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAbJ;AAeI;EACE,yBAAA;AAbN;AAiBE;EACE,gBAAA;AAfJ","sourcesContent":[".projects {\n  position: relative;\n  margin-right: 16px;\n\n  &__list {\n    position: absolute;\n    top: 100%;\n    right: 0;\n    margin-top: 14px;\n    min-width: 229px;\n    border: 1px solid #E0E7EB;\n    border-radius: 4px;\n    background: white;\n  }\n}\n\n.current {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n\n  &__icon {}\n\n  &__name {\n    margin-left: 6px;\n    font-weight: 400;\n    font-size: 14px;\n    white-space: nowrap;\n    max-width: 250px;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  &__arrow {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 10px;\n    transition: var(--transition);\n  }\n\n  &--open {\n    & .current {\n      &__arrow {\n        transform: scaleY(-1);\n      }\n    }\n  }\n}\n\n.project {\n  display: flex;\n  align-items: center;\n  padding: 6px 12px 6px;\n  position: relative;\n  border-bottom: 1px solid #E0E7EB;\n  cursor: pointer;\n\n  &:first-child {\n    padding-top: 6px;\n  }\n\n  &:last-child {\n    border-bottom: 0;\n    padding-bottom: 7px;\n  }\n\n  &--selected {\n    pointer-events: none;\n  }\n\n  &__name {\n    margin-left: 8px;\n    font-weight: 400;\n    font-size: 12px;\n    margin-right: 8px;\n  }\n\n  &__check {\n    display: flex;\n    align-items: center;\n    margin-left: auto;\n\n    & svg {\n      fill: var(--accent-color);\n    }\n  }\n\n  &:hover {\n    background: #EEE;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"projects": `SelectProject_projects__1rhBJ`,
	"projects__list": `SelectProject_projects__list__LtjjM`,
	"current": `SelectProject_current__OlJ8A`,
	"current__name": `SelectProject_current__name__7bYU8`,
	"current__arrow": `SelectProject_current__arrow__eSTp4`,
	"current--open": `SelectProject_current--open__8CM4c`,
	"project": `SelectProject_project__h5NE+`,
	"project--selected": `SelectProject_project--selected__51PLY`,
	"project__name": `SelectProject_project__name__dxLGL`,
	"project__check": `SelectProject_project__check__hI+a8`
};
export default ___CSS_LOADER_EXPORT___;
